<template>
  <div class="formbox">
    <h3>主办登录</h3>
    <Form
      ref="formInline"
      :model="formInline"
      :rules="ruleInline"
      @keyup.enter.native="handleSubmit('formInline')"
    >
      <FormItem prop="user">
        <Input type="text" v-model="formInline.user" placeholder="用户名">
          <template slot="prefix">
            <img src="../img/icon-1.png" width="14" />
          </template>
        </Input>
      </FormItem>
      <FormItem prop="password">
        <Input type="password" v-model="formInline.password" placeholder="密码">
          <template slot="prefix">
            <img src="../img/icon-2.png" width="14" />
          </template>
        </Input>
      </FormItem>
      <FormItem prop="captcha" class="form-code">
        <Input
          v-model="formInline.captcha"
          placeholder="验证码"
          prefix="md-mail-open"
        >
          <template slot="prefix">
            <img src="../img/icon-3.png" width="14" />
          </template>
        </Input>
        <img
          class="code"
          :src="code.image"
          alt="验证码"
          v-if="code && code.image"
          @click="getCode"
        />
      </FormItem>
      <div class="btn" @click="handleSubmit('formInline')">登录</div>
    </Form>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  data() {
    return {
      formInline: {
        user: "",
        password: "",
        captcha: "",
      },
      ruleInline: {
        user: [{ required: true, message: "用户为必填选项", trigger: "blur" }],
        password: [
          { required: true, message: "账号或密码错误", trigger: "blur" },
          {
            type: "string",
            min: 4,
            message: "密码不能小于4位",
            trigger: "blur",
          },
          {
            type: "string",
            max: 50,
            message: "密码不能大于50位",
            trigger: "blur",
          },
        ],
        captcha: [{ required: true, message: "验证码必填", trigger: "blur" }],
      },
      code: null, // 二维码信息
      loading: false,
    };
  },
  async created() {
    this.getCode();
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
    }),
  },
  methods: {
    ...mapMutations({
      setUser: "setUser",
      setRole: "setRole",
      setToken: "setToken",
      setTokenTime: "setTokenTime",
      setLogin: "setLogin",
      setCompany: "loginModule/setCompany",
      setExhibition: "loginModule/setExhibition",
    }),
    ...mapActions({
      getUser: "loginModule/getUser",
      getToken: "loginModule/getToken",
      getCompany: "loginModule/getCompany",
      getImgCode: "loginModule/getImgCode",
      validateImgCode: "loginModule/validateImgCode",
      getExhibitionById: "exhibitionModule/getExhibitionById",
      getDefaultJoinExhibition: "companyModule/getDefaultJoinExhibition",
    }),
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let codeValid = await this.validCode();
      if (!codeValid) return;
      let formData = {
        grant_type: "password",
        client_id: "cloud.exhibition",
        client_secret: "secret",
        username: form.user,
        password: form.password,
        scope: "synair offline_access",
        require_role: "host",
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let tokenData = await this.getToken(formData);
      if (tokenData) {
        this.setRole(1);
        this.setToken(tokenData.access_token);
        this.setTokenTime(tokenData.expires_in * 1000 + new Date().getTime());
        this.$Message.success("登录成功");
        this.setLogin(true);
        this.$router.push("/mobile-backend/ex-list");
      }
      this.loading = false;
    },
    async getCode() {
      // 获取code
      this.code = await this.getImgCode();
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    async validCode() {
      // 验证code
      if (!this.code || !this.formInline.captcha) return false;
      let valid = await this.validateImgCode({
        Key: this.code.key,
        Code: this.formInline.captcha,
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        this.$Message.error(valid.errors[0].description);
        this.getCode();
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.formbox {
  width: 330px;
  background-color: #fff;
  box-shadow: 0 5px 20px 0 rgba(24, 84, 200, 0.1);
  border-radius: 10px;
  padding: 0 20px;
  margin: 0 auto;
  position: relative;
  top: 20%;
  padding-bottom: 30px;
  h3 {
    font-size: 21px;
    color: #333;
    text-align: center;
    padding: 20px 0 40px;
    font-weight: 500;
  }
  /deep/ {
    .ivu-input {
      border: none;
      border-radius: 0;
      border-bottom: 1px solid #bfbfbf;
      outline: none;
    }
    .ivu-input-prefix {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .btn {
    width: 100%;
    height: 40px;
    margin-top: 30px;
    background-color: #0782ff;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #fff;
  }
}
.form-code {
  position: relative;
  .code {
    width: 50px;
    position: absolute;
    top: 7px;
    right: 8px;
    cursor: pointer;
  }
}
</style>